/**
 * The four corners — the mark every video player uses for "fill the screen",
 * and the same mark turned inward for "give it back".
 *
 * Drawn, not lettered: ⛶ is missing from enough system fonts to come out as a
 * box, on exactly the phones this button matters most on. Built on a 16-unit
 * grid and inheriting `currentColor`, like the block marks beside it.
 */
export function FullscreenIcon({ exiting }: { exiting: boolean }): React.JSX.Element {
    return (
        <svg viewBox="0 0 16 16" width="1em" height="1em" aria-hidden="true" focusable="false">
            {/* Corner brackets. Entering, they point out of the frame; leaving,
                the same four brackets are drawn a third of the way in and face
                the middle, so the pair reads as one gesture reversed. */}
            <path
                d={exiting
                    ? 'M5.2 1.6 V5.2 H1.6 M10.8 1.6 V5.2 H14.4 M5.2 14.4 V10.8 H1.6 M10.8 14.4 V10.8 H14.4'
                    : 'M1.6 5.6 V1.6 H5.6 M10.4 1.6 H14.4 V5.6 M1.6 10.4 V14.4 H5.6 M14.4 10.4 V14.4 H10.4'}
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
